import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Spin } from "antd";
import Loader from "../../../../core/common/loader";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  FilterConfirmProps,
  FilterDropdownProps,
} from "antd/es/table/interface";
import { Select, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Toast } from "react-bootstrap";
import { format } from "date-fns";
import { DateRange } from "react-date-range";

const { Option } = Select;

type Permission = { id: number; name: string };
type Admin = {
  id: number;
  academic_year_name: string;
  student_id: number;
  mobile_number: string;
  alternate_mobile_number: string | null;
  student_name: string;
  parent_name: string;
  email: string;
  dob: string;
  gender: string;
  state: string;
  district: string;
  address: string;
  current_school_name: string;
  current_class: string;
  enrolling_class: string;
  programs: any | null;
  is_enrollment: boolean;
  created_at: string;
  updated_at: string;
  lead_year: string | null;
  registration_date: string | null;
  target_exam: string | null;
  marks: string | null;
  marks_percentage: string | null;
  is_sc_student: boolean;
  scs_number: string | null;
  created_on: string | null;
  updated_on: string | null;
  varna_id: string | null;
  academic_year: number;
  agent: number;
  reference_type: string | null;
  lead_type: string | null;
  mode_of_exam: string | null;
  student: string | null;
};

type Agent = {
  id: number;
  username: string;
};

interface Branch {
  branch_id: number;
  name: string;
  label: string;
}

interface Class {
  class_name_id: number;
  name: string;
  label: string;
}

const NonChaitanyaSummerCampCallBacks = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState(0);
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [agents, setAgents] = useState<Agent[]>([]);
  const [agentsdata, setAgentsdata] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [filteredData, setFilteredData] = useState(admin);
  // const [selectedAgent, setSelectedagent] = useState<Option | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [agentsFilter, setAgentsFilter] = useState<Agent[]>([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedAgentFilter, setSelectedAgentFilter] = useState<string>("");
  const [selectedClass, setSelectedClass] = useState<string>("");
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [classesDropdown, setClassesDropdown] = useState<Class[]>([]);
  const [targetDate, setTargetDate] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [dangerToastMessage, setDangerToastMessage] = useState("");
  const [nextPageNumber, setNextPageNumber] = useState<number | null>(null); // Added nextPageNumber state
  // const [startDate, setStartDate] = useState<string | null>(null);
  // const [endDate, setEndDate] = useState<string | null>(null);
  const [previousPageNumber, setPreviousPageNumber] = useState<number | null>(
    null
  ); // Added previousPageNumber state

  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0)),
      key: "selection",
    },
  ]);

  const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");
  const [showCalendar1, setShowCalendar1] = useState(false);

  useEffect(() => {
    if (!checkPermission("view_summercampticket", "summercampticket")) {
      navigate(routes.adminDashboard);
    } else {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter,
        selectedClass,
        startDate || undefined,
        endDate || undefined
      );
      fetchBranches().then(setBranches);
      fetchAgentsData();
      fetchAgents();
      fetchClassesDropdown();
    }
  }, [userPermissions]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const handleFetchData = () => {
    if (startDate && endDate) {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter,
        selectedClass,
        startDate,
        endDate
      );
      setShowCalendar1(false);
    }
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: string,
    className: string,
    startDate = "",
    endDate = ""
  ) => {
    let apiUrl = `${webApi}/outdoor_summercamp/agent_od_call_backs/?page=${page}&page_size=${pageSize}`;

    if (searchText) apiUrl += `&search=${searchText}`;
    if (branchName) apiUrl += `&branch__name=${branchName}`;
    if (agentName) apiUrl += `&summercamp_agent__username=${agentName}`;
    if (className) apiUrl += `&student_class__name=${className}`;
    if (startDate) apiUrl += `&from_date=${startDate}`;
    if (endDate) apiUrl += `&to_date=${endDate}`;

    const response = await fetch(apiUrl, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchAgents = async () => {
    const resposne = await fetch(`${webApi}/user/users_dropdown/`, options);
    const data = await resposne.json();
    setAgents(Array.isArray(data) ? data : []);
  };

  const fetchClassesDropdown = async () => {
    const resposne = await fetch(
      `${webApi}/branches/branches_class_name_dropdown/`,
      options
    );
    const data = await resposne.json();
    setClassesDropdown(data.results);
  };

  const fetchBranches = async () => {
    const response = await fetch(
      `${webApi}/branches/brach_names_dropdown/`,
      options
    );
    const data = await response.json();
    return data.results;
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: string,
    className: string,
    startDate = "",
    endDate = ""
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(
          page,
          pageSize,
          searchText,
          branchName,
          agentName,
          className,
          startDate,
          endDate
        ),
      ]);

      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setFilteredData(groupsData.results);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      // setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setNextPageNumber(groupsData.next_page_number);
      setPreviousPageNumber(groupsData.previous_page_number);
      // Ensure agentsData is an array
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  useEffect(() => {
    fetchData(
      currentPage,
      pageSize,
      searchText,
      selectedBranch,
      selectedAgentFilter,
      selectedClass,
      startDate || undefined,
      endDate || undefined
    );
  }, [
    currentPage,
    selectedBranch,
    selectedAgentFilter,
    selectedClass,
    pageSize,
  ]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter,
        selectedClass,
        startDate || undefined,
        endDate || undefined
      );
    }
  };

  const agentsOptions = agents.map(
    (agent: { id: { toString: () => any }; username: any }) => ({
      value: agent.id.toString(),
      label: agent.username,
    })
  );

  const [selectedName, setSelectedName] = useState<string | null>(null);
  const [selectedSCSNumber, setSelectedSCSNumber] = useState<string | null>(
    null
  );

  // useEffect(() => {
  //   const applyFilters = () => {
  //     let filtered = admin;
  //     if (selectedName && selectedSCSNumber) {
  //       filtered = filtered.filter(
  //         (item) =>
  //           item.name.includes(selectedName) &&
  //           item.SCS_Number.includes(selectedSCSNumber)
  //       );
  //     } else if (selectedName) {
  //       filtered = filtered.filter((item) => item.name.includes(selectedName));
  //     } else if (selectedSCSNumber) {
  //       filtered = filtered.filter((item) =>
  //         item.SCS_Number.includes(selectedSCSNumber)
  //       );
  //     }
  //     setFilteredData(filtered);
  //   };
  //   applyFilters();
  // }, [admin]);

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { student_id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.student_id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const fetchAgentsData = async () => {
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_agents_by_agent_group/1/`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentChange = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/students/bulk_summer_camp_agents_change/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
          }),
        }
      );
      const data = await response.json();
      console.log("Agent updated successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter,
        selectedClass,
        startDate || undefined,
        endDate || undefined
      );
    } catch (error) {
      console.error("Failed to update agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/agentsaletarget/assign_target_to_agent/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
            target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setDangerToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setTargetDate("");
      setAsignShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter,
        selectedClass,
        startDate || undefined,
        endDate || undefined
      );
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentChangeFilter = (agentName: string) => {
    setSelectedAgentFilter(agentName);
  };

  const handleClassChange = async (className: string) => {
    setSelectedClass(className);
    // Call fetchData with the new class name
  };

  useEffect(() => {
    setTimeout(() => {
      setshowSolidSuccessToast(false);
      setShowSolidDangerToast(false);
    }, 3000);
  }, [toastMessage, dangerToastMessage]);

  const handleBranchChange = (branchName: string) => {
    setSelectedBranch(branchName);
  };

  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => {
    setShowSolidDangerToast(false);
  };
  const columns = [
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_text: any, record: { student_id: any; SCS_Number: any }) => (
    //     <Checkbox
    //       checked={selectedRowKeys.includes(record.student_id)}
    //       onChange={() =>
    //         handleSelect(record.student_id, selectedRowKeys, setSelectedRowKeys)
    //       }
    //     />
    //   ),
    //   key: "action",
    //   align: "center",
    // },
    {
      title: "Action",
      dataIndex: "callbacktime",
      render: (_text: any, record: { callbacktime: string }) => {
        const now = new Date();
        const today = now.toDateString();
        const callbackDate = new Date(record.callbacktime).toDateString();
  
        let backgroundColor = "";
        if (new Date(record.callbacktime) < now) {
          backgroundColor = "rgba(255, 0, 0, 0.5)";
        } else if (callbackDate === today) {
          backgroundColor = "rgba(255, 165, 0, 0.5)";
        } else if (new Date(record.callbacktime) > now) {
          backgroundColor = "rgba(0, 255, 0, 0.5)"; 
        }
  
        return (
          <div
            style={{
              backgroundColor,
              width: "15px", // Adjust size as needed
              height: "15px",
              display: "inline-block", // Ensures it displays properly
            }}
          />
        );
      },
      key: "callbacktime",
      align: "center",
    },
    // {
    //       title: "Academic Year",
    //       dataIndex: "academic_year_name",
    //       render: (
    //         text:
    //           | string
    //           | number
    //           | boolean
    //           | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    //           | Iterable<React.ReactNode>
    //           | React.ReactPortal
    //           | null
    //           | undefined,
    //         record: { student_id: any }
    //       ) => (
    //         <Link
    //           to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
    //         >
    //           {text}
    //         </Link>
    //       ),
    //     },
        {
          title: "Mobile Number",
          dataIndex: "mobile_number",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "Name",
          dataIndex: "student_name",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        // {
        //   title: "Parent Name",
        //   dataIndex: "parent_name",
        //   render: (
        //     text:
        //       | string
        //       | number
        //       | boolean
        //       | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        //       | Iterable<React.ReactNode>
        //       | React.ReactPortal
        //       | null
        //       | undefined,
        //     record: { student_id: any }
        //   ) => (
        //     <Link
        //       to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
        //     >
        //       {text}
        //     </Link>
        //   ),
        // },
        {
          title: "Gender",
          dataIndex: "gender",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "State",
          dataIndex: "state",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "District",
          dataIndex: "district",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "Current School",
          dataIndex: "current_school_name",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "Current Class",
          dataIndex: "current_class",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
        {
          title: "Enrolling Class",
          dataIndex: "enrolling_class",
          render: (
            text:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined,
            record: { student_id: any }
          ) => (
            <Link
              to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
            >
              {text}
            </Link>
          ),
        },
    {
      title: "Time",
      dataIndex: "callbacktime",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { no_of_attempts: number; student_id: any }
      ) => (
        <Link
        to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
      >
        {text}
      </Link>
      ),
    },
    {
      title: "Agent",
      dataIndex: "agent_name",
      // key: "agent_name",
      // filters: agentsDropdown.map((agent) => ({
      //   text: agent.username,
      //   value: agent.username,
      // })),
      // onFilter: (value: any, record: { agent_name: string | any[] }) =>
      //   record.agent_name.includes(value),
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }: {
      //   setSelectedKeys: (keys: string[]) => void;
      //   selectedKeys: string[];
      //   confirm: () => void;
      //   clearFilters: () => void;
      // }) => (
      //   <div style={{ padding: 8 }}>
      //     <Select
      //       showSearch
      //       placeholder="Select Agent"
      //       onSearch={(value) => setSelectedKeys(value ? [value] : [])}
      //       onSelect={(value) => {
      //         setSelectedKeys([value]);
      //         handleAgentChangeFilter(value); // Include handleAgentChange here
      //         confirm();
      //       }}
      //       value={selectedKeys[0]}
      //       style={{ width: 200 }}
      //     >
      //       {agentsDropdown.map((agent) => (
      //         <Option key={agent.id} value={agent.username}>
      //           {agent.username}
      //         </Option>
      //       ))}
      //     </Select>
      //     <Button
      //       type="primary"
      //       onClick={() => confirm()}
      //       icon={<SearchOutlined />}
      //       size="small"
      //       style={{ width: 90, marginRight: 8 }}
      //     >
      //       Search
      //     </Button>
      //     <Button
      //       onClick={() => {
      //         clearFilters();
      //         confirm();
      //         handleAgentChangeFilter("");
      //       }}
      //       size="small"
      //       style={{ width: 90 }}
      //     >
      //       Reset
      //     </Button>
      //   </div>
      // ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
        to={`${routes.NonChaitanyaSummerCampTicket}?id=${record.student_id}&s1=3`}
      >
        {_text}
      </Link>
      ),
    },
  ];

  const Preloader = () => {
    return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
  };

  useEffect(() => {
    console.log(selectedRowKeys);
  }, [selectedRowKeys]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Non Chaitanya SummerCamp CallBack Data</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CallBack Data
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap"></div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Students List</h4>

              <div className="d-flex align-items-center flex-wrap ms-auto">
                {/* <Checkbox
                    indeterminate={
                      selectedRowKeys.length > 0 &&
                      selectedRowKeys.length < admin.length
                    }
                    checked={selectedRowKeys.length === admin.length}
                    onChange={(e) =>
                      handleSelectAll(e, admin, setSelectedRowKeys)
                    }
                  >
                    Select All
                  </Checkbox>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Change Agent
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => setAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px", marginRight:"5px" }}
                  >
                    Assign Agent
                  </button> */}
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => setShowCalendar1(!showCalendar1)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#34303D",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      minWidth: "200px",
                      justifyContent: "center",
                      // marginTop: "5px",
                      marginRight: "5px",
                      marginBottom: "7px",
                    }}
                  >
                    {format(dateRange[0].startDate, "dd MMM yy")} –{" "}
                    {format(dateRange[0].endDate, "dd MMM yy")}
                    <span style={{ marginLeft: "10px" }}>▼</span>
                  </div>

                  {/* Calendar Popup (Positioned Below) */}
                  {showCalendar1 && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 2000,
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        padding: "5px",
                        left: "-130px" /* Move the element to the left */,
                      }}
                    >
                      <DateRange
                        ranges={dateRange}
                        onChange={(item) =>
                          setDateRange([
                            {
                              startDate: item.selection.startDate || new Date(),
                              endDate: item.selection.endDate || new Date(),
                              key: "selection",
                            },
                          ])
                        }
                        moveRangeOnFirstSelection={false}
                        rangeColors={["blue"]} // Dark color from your UI
                      />
                    </div>
                  )}
                </div>

                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#28a745",
                    borderColor: "#28a745",
                    color: "#fff",
                    height: "38px",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    // marginTop: "0.5rem",
                    marginBottom: "7px",
                     borderRadius:"19px"
                  }}
                  onClick={handleFetchData}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onKeyDown={(e) => handleKeyDown(e)}
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    Selection={false}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      locale: { items_per_page: "" },
                      nextIcon: <span>Next</span>,
                      prevIcon: <span>Prev</span>,
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      total: totalCount,
                      showTotal: (total: any, range: any[]) =>
                        `${range[0]}-${range[1]} of ${total}`,
                    }}
                    onChange={handleTableChange} // Move this outside of pagination
                    onSearch={handleSearch}
                  />
                </>
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {showCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              {/* <div className="card-header">
                <h4
                  className="modal-title"
                  style={{
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Change Agent
                </h4>
              </div> */}
              <form onSubmit={handleAgentChange}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
        {AsignshowCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              <form onSubmit={handleAgentAssignment}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Target Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={targetDate}
                          onChange={(e) => setTargetDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setAsignShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}

        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}

        <Toast
          show={showSolidSuccessToast}
          onClose={handleSolidSuccessToastClose}
          id="solidSuccessToast"
          className="colored-toast bg-success text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>

        <Toast
          show={showSolidDangerToast}
          onClose={handleSolidDangerToastClose}
          id="solidDangerToast"
          className="colored-toast bg-danger text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{dangerToastMessage}</Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default NonChaitanyaSummerCampCallBacks;
